"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogHeader = void 0;

var react_1 = __importDefault(require("react"));

var date_fns_1 = require("date-fns");

var BlogHeader_styles_1 = require("./BlogHeader.styles");

var BlogHeader = function BlogHeader(props) {
  return react_1.default.createElement("div", {
    className: "blog-header"
  }, react_1.default.createElement(BlogHeader_styles_1.BlogHeaderImage, {
    className: "blog-header-image",
    "data-testid": "blog-header-image"
  }, props.image && props.image()), react_1.default.createElement(BlogHeader_styles_1.BlogHeaderTitle, {
    className: "blog-header-title",
    "data-testid": "blog-title"
  }, props.title), react_1.default.createElement(BlogHeader_styles_1.BlogHeaderPublishDate, {
    className: "blog-header-publish-date",
    "data-testid": "blog-publish-date",
    color: props.publishDateColor
  }, "PUBLISHED ON ", date_fns_1.format(props.publishDate, 'dd/MM/yy')));
};

exports.BlogHeader = BlogHeader;